import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Chip,
  Paper,
  Typography,
  Grid,
  IconButton, 
} from "@mui/material";
import {
  NoDataFoundRow,
  StyledTableCell,
  StyledTableContainer,
  StyledTableRow,
} from "../../../components/common/StyledTableComponents";
import { useDispatch, useSelector } from "react-redux";
import { getdeleteduserslistApi } from "../../../features/Admin/Reports/AdminReports";
import dayjs from "dayjs";
import Loader from "../../../components/common/Loader/Loader";

import { debounce } from "lodash";
import { notifyError, notifySuccess } from "../../../utils/notificationMsg";
import { ProcessForClientRefundPayment } from "../../../features/Admin/AdminPayout/AdminPayoutAPI";
import CloseIcon from "@mui/icons-material/Close";
import AdminControl from "../../../components/common/AdminControl";
import { OfferDeclineApi } from "../../../features/Admin/OfferDecline/OfferDecline";
import { tr } from "date-fns/locale";
import CustomPagination from "../../../components/common/CustomPagination";
import { convertTimestampToDate } from "../../../utils/helpers";
const OfferDeclineCandidatePage = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
    const today = localStorage.getItem('serverTime') ? new Date(localStorage.getItem('serverTime')) : new Date();
  const [fromDate, setFromDate] = useState(
    dayjs(today).subtract(1, "year").toDate()
  );
  const [toDate, setToDate] = useState(dayjs(today).toDate());
  const [lodaing, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [Count, setCount] = useState(1);
  const [selectedIds, setSelectedIds] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isStripeDisabled, setStripeDisabled] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loadingOnline, setLoadingOnline] = useState(false);
 

  const onClose = () => {
    setIsModalOpen(false);
    setSelectedIds("");
  };

  const handleSubmit = (row) => {
    let id = row._id.$oid;
    setSelectedIds(id);
    setStripeDisabled(row.paymentmode === "offline");
    setIsModalOpen(true);
  };

  const handlePayment = async (method) => {
    setLoading(true); // Start loading
    const data = {
      candidate_id: selectedIds +" hello",
      payment_method: method,
      
    };

    try {
      const { payload } = await dispatch(ProcessForClientRefundPayment(data)); // Dispatch the API call
      console.log(payload); // Log the API response for debugging

      if (payload.status === 200) {
        notifySuccess(payload.message); // Show success notification
        await GetPayOutDetails(); // Refresh data (if asynchronous, await it)
        setIsModalOpen(false); // Close the modal
      } else {
        notifyError(payload.message); // Show error notification for non-200 responses
      }
    } catch (err) {
      console.error("Error processing payment:", err); // Log any errors
      notifyError(
        "An error occurred while processing the payment. Please try again."
      );
    } finally {
      setLoading(false); // Stop loading
    }
  };

 

  function formatDate(dateString) {
    if (!dateString) {
      return "Invalid Date"; // Handle case where dateString is undefined or invalid
    }

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date"; // Handle invalid date
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  }

  const GetPayOutDetails = async (
    query = "",
    pageNum = 1,
    startDate = fromDate,
    endDate = toDate,
    pageSize=rowsPerPage
  ) => {
    setSelectedIds("");
    setLoading(true);
    let data = {
      fromDate: formatDate(startDate),
      toDate: formatDate(endDate),
      pagenumber: pageNum,
      pagesize: pageSize,
      export: false,
      searchitem: query.trim(),
    };


    try {
      const { payload } = await dispatch(OfferDeclineApi(data));
      if (payload.status === 200) {
        let data = payload.data || [];
        setData(data);
        setCount(payload.totalRecords)
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const GetPayOutDetailsReset = async () => {
    setLoading(true);
    setSearchQuery("");
    let from = dayjs().subtract(1, "year").toDate();
    let to = dayjs().toDate();
    setFromDate(from);
    setToDate(to);
    setPage(1);
    setRowsPerPage(10);

    let data = {
      fromDate: formatDate(from),
      toDate: formatDate(to),
    };
    try {
      const { payload } = await dispatch(OfferDeclineApi(data));
      if (payload.status === 200) {
        setData(payload.data);
        setCount(payload.totalRecords);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const handleFromDateChange = (date) => {
    setFromDate(date); // Update the from date
    // If the new from date is greater than the current to date, reset the to date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  useEffect(() => {
    GetPayOutDetails();
  }, []);

  const debouncedSearch = useCallback(
    debounce((query, updatedFrom, updatedTo) => {
      GetPayOutDetails(query, updatedFrom, updatedTo);
    }, 1300),
    []
  );
  useEffect(() => {
    setPage(1);
    debouncedSearch(searchQuery,1 ,fromDate, toDate);
  }, [searchQuery]);

  
  const handlePageChange = (value) => {
    setPage(value);
    GetPayOutDetails(searchQuery, value);
  };
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setPage(1);
    setRowsPerPage(newRowsPerPage);
    GetPayOutDetails(searchQuery, 1, fromDate, toDate, newRowsPerPage);
  };

  return (
    <>
      <AdminControl
        title={"Refund to Client"}
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        GetFunction={GetPayOutDetails}
        ResetFunction={GetPayOutDetailsReset}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      {lodaing ? (
        <Loader />
      ) : (
        <Box>
          <StyledTableContainer component={Paper} sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#ECF1FF" }}>
                  <StyledTableCell>No.</StyledTableCell>
                  <StyledTableCell>Name of Candidate</StyledTableCell>
                  <StyledTableCell>Job Title</StyledTableCell>
                  <StyledTableCell>Email</StyledTableCell>
                  <StyledTableCell>Contact No.</StyledTableCell>
                  <StyledTableCell>Offer Declined By</StyledTableCell>
                  <StyledTableCell>Uploaded By</StyledTableCell>
                  <StyledTableCell>Status Modified Date</StyledTableCell>
                  <StyledTableCell>Actions</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data.length > 0 ? (
                  <>
                    {data.map((row, index) => {
                      let ids = row?._id.$oid;
                      const OfferRejectDate = row.candidate_statusinfo.find(
                        (statusInfo) =>
                          statusInfo.status.toLowerCase() === "offer declined"
                      );
                      const offerRejectDate = OfferRejectDate
                        ? convertTimestampToDate(OfferRejectDate.cdate.$date)
                        : "";

                      return (
                        <TableRow
                          key={index}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "#f5f5f5",
                            },
                            fontSize: "12px",
                          }}
                        >
                          <StyledTableRow>{row.serialnumber}.</StyledTableRow>
                          <StyledTableRow>{`${row.candidate_firstname} ${row.candidate_lastname}`}</StyledTableRow>
                          <StyledTableRow>
                            {row.candidate_company[0]?.job_title}
                          </StyledTableRow>
                          <StyledTableRow>{row.candidate_email}</StyledTableRow>
                          <StyledTableRow sx={{ minWidth: "160px" }}>
                            {row.candidate_contactno}
                          </StyledTableRow>
                          <StyledTableRow sx={{ minWidth: "160px" }}>
                            {row.client_name}
                          </StyledTableRow>

                          <StyledTableRow
                            sx={{
                              textTransform: "capitalize",
                              minWidth: "160px",
                            }}
                          >
                            {`${row.recruiter_name} (${row.user_type})`}
                          </StyledTableRow>

                          <StyledTableRow>{offerRejectDate}</StyledTableRow>
                          <StyledTableRow>
                            <Button
                              variant="contained"
                              color="success" // Apply success color
                              sx={{
                                mx: {
                                  xs: 0,
                                  sm: 1,
                                },
                                fontFamily: "Urbane-Light",
                                fontSize: "12px",
                                mt: { xs: 2, sm: 0 },
                              }}
                              onClick={() => handleSubmit(row)}
                            >
                              Refund
                            </Button>
                          </StyledTableRow>
                        </TableRow>
                      );
                    })}


                  </>
                ) : (
                  <>
                    <NoDataFoundRow
                      colSpan={9}
                      message="Candidates are not available!"
                    />
                  </>
                )}
              </TableBody>
            </Table>
          </StyledTableContainer>
          {data?.length > 0 && (
          <CustomPagination
          totalRecords={Count}
          rowsPerPageOptions={[10, 25, 50, 100]}
          initialRowsPerPage={rowsPerPage}
          setRowsPerPage1={setRowsPerPage}
          initialPage={page - 1}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
        )}
        </Box>
      )}



      <Dialog
        open={isModalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            onClose();
          }
        }}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "17px",
            maxWidth: "450px",
          },
        }}
      >
        <DialogTitle sx={{ padding: 0, borderRadius: "25%" }}>
          <Box
            sx={{
              backgroundColor: "#250258",
              padding: "12px 16px",
              position: "relative",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "white",
                fontFamily: "Urbane-Light",
                fontWeight: 600,
                fontSize: "15px",
              }}
            >
              Payment Details{" "}
            </Typography>
            <IconButton
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "white",
              }}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent
          sx={{
            m: 1,
          }}
        >
          <Paper elevation={1} sx={{ padding: 8, textAlign: "center" }}>
            <Typography variant="subtitle1" gutterBottom>
              To complete the payment process, please choose one of the
              following options:
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handlePayment("stripe")}
                  disabled={isStripeDisabled}
                  sx={{
                    backgroundColor: "#250258",
                    color: "#fff",
                    "&.Mui-disabled": {
                      backgroundColor: "#d3d3d3", // Set the disabled background color
                      color: "#a1a1a1", // Set the disabled text color
                    },
                  }}
                >
                  Pay With Stripe
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => handlePayment("cash")}
                  style={{ backgroundColor: "#dc3545" }}
                  disabled={loadingOnline}
                >
                  Pay With Cash
                </Button> 
              </Grid>
            </Grid>
            {isStripeDisabled && (
              <Typography variant="body2" color="error">
                The Stripe button is disabled because some recruiters don’t have
                an active Stripe account connected.
              </Typography>
            )}
          </Paper>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OfferDeclineCandidatePage;

("670f880055281ab03d618cb9 , 670f880055281ab03d618cb9 , 670f880055281ab03d618cb9 , 670f880055281ab03d618cb9 , 670f880055281ab03d618cb9");
